var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-alert-item"},[_c('img',{staticClass:"print-alert-item__company-logo",attrs:{"src":_vm.logo,"alt":"Logo da transportadora"}}),_vm._v(" "),_c('div',{staticClass:"print-alert-item__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }